import Controller from "./pendingBooking.controller";
import template from "./pendingBooking.html";

const pendingBooking = {
  template,
  controller: Controller,
};

export default pendingBooking;



// WEBPACK FOOTER //
// ./src/pages/pendingBooking/pendingBooking.component.js